import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";
import { useAuth } from "../contexts/AuthContext";
import { loginUser } from "../services/authService";
import InputField from "../utils/InputField";
import { useToast } from '../contexts/ToastContext';
import { useLoading } from "../contexts/LoadingContext";

function Login() {
  const { login } = useAuth();
  const { showToast } = useToast();
  const { startLoading, stopLoading } = useLoading();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [serverError, setServerError] = useState("");

  const handleFieldChange = (field, value) => {
    if (field === "username") setUsername(value);
    if (field === "password") setPassword(value);
  };

  const validateForm = () => {
    const errors = {};
    if (!username) errors.username = "Email is required";
    if (!password) errors.password = "Password is required";
    return errors;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setServerError("");

    // Validate form fields
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    // API call
    try {
      startLoading();
      const data = await loginUser(username, password);
      login(data.accessToken);
      showToast('Login successfully!', 'success');
    } catch (error) {
      showToast(error.message || "Login failed. Please try again.", 'error');
      setServerError(error.message || "Login failed. Please try again.");
    } finally {
      stopLoading();
    }
  };

  return (
    <section>
      <Container
        className="d-flex align-items-center justify-content-center login-background"
        fluid
      >
        <div className="login-modal">
          <div className="d-flex justify-content-center">
            <img src="logo.svg" alt="Logo" className="login-logo" />
          </div>
          {serverError && <Alert variant="danger">{serverError}</Alert>}
          <Form onSubmit={handleLogin}>
            <Row className="px-0 mb-3">
              <InputField
                field="username"
                label="Email"
                type="email"
                value={username}
                onChange={handleFieldChange}
                error={validationErrors.username}
                as={Col}
                controlId="loginUserMail"
              />
            </Row>
            <Row className="px-0 mb-3">
              <InputField
                field="password"
                label="Password"
                type="password"
                value={password}
                onChange={handleFieldChange}
                error={validationErrors.password}
                as={Col}
                controlId="loginUserPassword"
              />
            </Row>
            <Button
              className="login-button mt-3"
              id="loginUserButton"
              size="xl"
              type="submit"
            >
              Login
            </Button>
          </Form>
        </div>
      </Container>
    </section>
  );
}

export default Login;
